import { gql } from "@apollo/client";

export const CREATE_EXPENSE_GROUP = gql`
  mutation CreateGroupExpense($title: String!, $remark: String, $code: String) {
    createGroupExpense(title: $title, remark: $remark, code: $code) {
      status
      message
    }
  }
`;
export const GET_EXPENSE_GROUP_WITH_PAGINATION = gql`
  query GetGroupExpensePagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
  ) {
    getGroupExpensePagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
    ) {
      data {
        _id
        title
        code
        remark
        createdAt
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_EXPENSE_GROUP = gql`
  mutation UpdateGroupExpense(
    $id: String!
    $title: String!
    $remark: String
    $code: String
  ) {
    updateGroupExpense(_id: $id, title: $title, remark: $remark, code: $code) {
      status
      message
    }
  }
`;

export const DELETE_EXPENSE_GROUP = gql`
  mutation DeleteGroupExpense($id: String!) {
    deleteGroupExpense(_id: $id) {
      status
      message
    }
  }
`;
